import React from 'react';

const FieldHelp = React.createClass({
    propTypes: {
        text: React.PropTypes.string.isRequired,
        active: React.PropTypes.bool.isRequired
    },

    getInitialState: function() {
        return {
            isActive: this.props.active,
        };
    },

    closeHelp() {
        this.setState({ isActive: false });
    },

    render() {
        if (this.props.active) {
            return (
                <div className="hint-container">
                    <div className="hint">
                        <div className="arrow arrow-left" />
                        <div dangerouslySetInnerHTML={{__html:this.props.text}} />
                    </div>
                </div>
            );
        } else {
            return(null);
        }
    }
});

export default FieldHelp;


/** WEBPACK FOOTER **
 ** ./src/components/Fields/HelpText.js
 **/